<template>
    <v-container fluid class="pa-0">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-card v-if="dPriAlumno.IdAlumno" class="bsp_header rounded-lg elevation-3 overflow-hidden">
            <v-row no-gutters align="center">
                <v-col cols="12" sm="1" class="d-flex justify-center pa-4">
                    <v-avatar v-if="dPriAlumno.Foto==''" size="85" class="ma-1">
                        <img src="@/assets/images/businessman.png" alt="Postulante">
                    </v-avatar>
                    <v-hover v-else v-slot:default="{ hover , props }">
                        <v-img
                            v-bind="props"
                            :src="dPriAlumno.Foto"
                            alt="Foto del Alumno"
                            :class="{ 'hover-scale': hover  }"
                            contain
                            max-height="85"
                        />
                    </v-hover>
                </v-col>
                <v-col cols="12" sm="5" lg="3" class="pa-1">
                    <div class="d-flex align-center mb-2">
                        <v-icon left dark>face</v-icon>
                        <v-chip label x-small color="rgba(255,255,255,0.2)" dark class="mr-1">NOMBRE</v-chip>
                        <span class="text-h6 font-weight-bold white--text text-truncate">{{ dPriAlumno.Alumno }}</span>
                        <v-icon x-small @click="fuCopy(dPriAlumno.Alumno)" right dark>content_copy</v-icon>
                    </div>
                    <div class="d-flex align-start mt-2">
                        <v-icon left dark>school</v-icon>
                        <v-chip label x-small color="rgba(255,255,255,0.2)" dark class="mr-1">CARRERA</v-chip>
                        <span class="text-body-2 white--text font-weight-medium">{{dPriAlumno.priservicio.Iniciales}} - {{ dPriAlumno.priservicio.Descripcion }}</span>
                    </div>
                    <div class="d-flex align-center mb-1">
                        <v-icon left dark>qr_code_2</v-icon>
                        <v-chip label x-small color="rgba(255,255,255,0.2)" dark class="mr-1">CÓDIGO</v-chip>
                        <span class="text-body-2 white--text font-weight-medium">{{ dPriAlumno.Codigo }}</span>
                        <v-icon x-small @click="fuCopy(dPriAlumno.Codigo)" right dark>content_copy</v-icon>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" lg="2" class="pa-1">
                    <div class="d-flex align-center mb-1">
                        <v-icon left dark>credit_card</v-icon>
                        <v-chip label x-small color="rgba(255,255,255,0.2)" dark class="mr-1">DNI</v-chip>
                        <span class="text-h6 font-weight-bold white--text text-truncate">{{ dPriAlumno.DNI }}</span>
                        <v-icon x-small @click="fuCopy(dPriAlumno.DNI)" right dark>content_copy</v-icon>
                    </div>
                    <div class="d-flex align-center mb-1">
                        <v-icon @click="fuContactWhatsApp(dPriAlumno.Celular)" left dark color="success">textsms</v-icon>
                        <v-chip label x-small color="rgba(255,255,255,0.2)" dark class="mr-1">CELULAR</v-chip>
                        <v-text-field @click:append="fuAlumnoSave()" @keyup.enter="fuAlumnoSave()" v-model="dPriAlumno.Celular" append-icon="save" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 9) || 'El campo debe ser menor de 9 caracteres.']" :maxlength="9" autocomplete="off" clearable counter dense style="font-size: 20px !important;" dark></v-text-field>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" lg="2" class="pa-1">
                    <div class="d-flex align-center mb-2">
                        <v-btn @click.prevent="dAccion=0" rounded block color="success" dark>Matricular</v-btn>
                    </div>
                    <div class="d-flex align-center mb-1">
                        <v-autocomplete v-model="dAccion"
                            :items="[
                                {text: 'Datos Generales', value: 1},
                                {text: 'Contacto', value: 2},
                                {text: 'Documentos', value: 3},
                                {text: 'Historial Laboral', value: 4},
                                {text: 'Seguimiento', value: 5},
                                {text: 'Becas', value: 6},
                                {text: 'Otro Instituto', value: 7}
                            ]" dense filled clearable rounded hide-details light background-color="white" color="primary"
                        ></v-autocomplete>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="rounded-lg elevation-3 overflow-hidden">
            <v-row no-gutters>
                <v-col v-if="dAccion==0" cols="12" sm="12" class="pa-1 blue lighten-5">
                    <CMatriculaByAlumno v-if="dPriAlumno" :pIdAlumno="parseInt(dPriAlumno.IdAlumno)"/>
                </v-col>
                <v-col v-if="dAccion==1" cols="12" sm="12" class="pa-1 blue lighten-5">
                    <CPriAlumnoItem v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                </v-col>
                <v-col v-if="dAccion==2" cols="12" sm="12" class="pa-1 blue lighten-5">
                    <CTlfAlumno v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                </v-col>
                <v-col v-if="dAccion==3" cols="12" sm="12" class="pa-1 blue lighten-5">
                    <CPriAlumnoDocs v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                </v-col>
                <v-col v-if="dAccion==4" cols="12" sm="12" class="pa-1 blue lighten-5">
                    <CDtlLaboralAlumno v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                </v-col>
                <v-col v-if="dAccion==5" cols="12" sm="12" class="pa-1 blue lighten-5">
                    <CMatConsejeria v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                </v-col>
                <v-col v-if="dAccion==6" cols="12" sm="12" class="pa-1 blue lighten-5">
                    <CPriAlumnosBecado :pIdAlumno="parseInt($route.params.pIdAlumno)"/>
                </v-col>
                <v-col v-if="dAccion==7" cols="12" sm="12" class="pa-1 blue lighten-5">
                    <CPriAlumnosInstituto v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>
<script>
import gql from 'graphql-tag';
import {fuCopy} from '@/helpers/index.js';
import CPriAlumnoCabecera from '@/components/PRI/PriAlumnoCabecera.vue';
import CPriAlumnoItem from '@/components/PRI/PriAlumnoItem.vue';
import CPriAlumnoDocs from '@/components/PRI/PriAlumnoDocs.vue';
import CMatriculaByAlumno from '@/components/Academico/MatriculaByAlumno.vue';
import CTlfAlumno from '@/components/Academico/TlfAlumno.vue';
import CMatMatriculaListByIdAlumno from '@/components/Academico/MatMatriculaListByIdAlumno.vue';
import CMatConsejeria from '@/components/Academico/MatConsejeria.vue'
import CPriAlumnosBecado from '@/components/Academico/PriAlumnosBecado.vue'
import CPriAlumnosInstituto from '@/components/PRI/PriAlumnosInstituto.vue'
import CDtlLaboralAlumno from '@/components/PRI/DtlLaboralAlumno.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'AlumnoItem',
    components: {CPriAlumnoCabecera, CPriAlumnoItem, CPriAlumnoDocs, CMatMatriculaListByIdAlumno, CTlfAlumno, CMatConsejeria, CPriAlumnosBecado, CPriAlumnosInstituto, CMatriculaByAlumno, CDtlLaboralAlumno},
    mounted(){
        if(this.$route.params.pIdAlumno)
            this.fuLoad(this.$route.params.pIdAlumno);
    },
    data: () => ({
        dLoading: false,
        dAccion: null,
        dPriAlumno: {
            IdAlumno:''
        },
    }),
    methods: {
        fuCopy,
        async fuLoad(p_IdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query matriculaPrev($IdAlumno: ID!){
                            prialumno(IdAlumno: $IdAlumno){
                                IdAlumno
                                Alumno
                                DNI
                                Codigo
                                Celular
                                Foto
                                priservicio{
                                    IdServicio
                                    Iniciales
                                    Descripcion
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: p_IdAlumno,
                    }
                })                
                this.dPriAlumno = response.data.prialumno;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        fuContactWhatsApp(p_celular) {
            window.open('https://api.whatsapp.com/send/?phone='+p_celular, '_blank');
        }
    }
}
</script>
<style scoped>
    .hover-scale {
        transform: scale(3);
        transition: transform 0.3s ease-in-out;
    }
    .bsp_header {
        background: linear-gradient(130deg, transparent 0% 87%, rgba(255, 255, 255, .6) 87.1% 100%),
                    linear-gradient(130deg, transparent 0% 75%, rgba(255, 255, 255, .4) 75.1% 100%),
                    linear-gradient(90deg, transparent 0% 35%, rgba(255, 255, 255, .3) 65.1% 100%),
                    linear-gradient(130deg, transparent 0% 60%, rgba(255, 255, 255, .2) 60.1% 100%),
                    linear-gradient(90deg, #3498db 0%, #2980b9 100%); /* Color base reemplazando var(--headerPrimary) */
        color: white;
    }
</style>
